import { Call, Email, EmojiPeople, Sms, WhatsApp } from "@material-ui/icons";
import { shallowEqual } from "react-redux";
import XToneImage from "../images/220214-CTN_012_alpha_2.png";
import CryoCabinImage from "../images/cryocabin.png";
import ECabinImage from "../images/ecabin_white.png";
import EQCryoImage from "../images/eqcryo.png";
import VetCryoImage from "../images/vetcryo.png";
import XCryoImage from "../images/xcryo_new.jpeg";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import EnvSettings from "./EnvSettings";

const server = EnvSettings.server;

export const AWS_IMAGE_HOSTING_TAG =
  "https://ctn-public-hosting.s3.eu-west-1.amazonaws.com/website_images/";
export const CRYOCABIN = "CRYO°CABIN";
export const XCRYO = "X°CRYO";
export const EQCRYO = "EQ°CRYO";
export const VETCRYO = "VET°CRYO";
export const ECABIN = "E°CABIN";
export const XTONE = "X°TONE";
export const OXYHH1 = "OXYPRO HH1";
export const OXYHS1 = "OXYPRO HS1";
export const OXYVS1 = "OXYPRO VS1";
export const OXYVH1 = "OXYPRO VH1";
export const OXYVH2 = "OXYPRO VH2";
export const OXYVH3 = "OXYPRO VH3";
export const OXYVH4 = "OXYPRO VH4";
export const LEDPRO = "LEDPRO";
export const QUATTRO = "MONOLITH QUATTRO";

/**
 * - Identification for permissionlevels
 * - NOTE: Remeber to add these user groups to backend as well
 */
export const USER_GROUPS = {
  ADMIN: 1,
  CLIENT: 2,
  SUPER_USER: 99,
  PRODUCTION: 10,
  SALES: 11,
  CLIENT_MAINTENANCE: 22,
};

export const TICKET_PRIORITIES = {
  HIGH: 3,
  NORMAL: 2,
  LOW: 1,
};

export const contactMethods = [
  {
    value: "email",
    label: "Email",
    icon: Email,
  },
  {
    value: "sms",
    label: "SMS Message",
    icon: Sms,
  },
  {
    value: "call",
    label: "Phone Call",
    icon: Call,
  },
  {
    value: "whatsappmessage",
    label: "WhatsApp Message",
    icon: WhatsApp,
  },
  {
    value: "whatsappcall",
    label: "WhatsApp Call",
  },
  {
    value: "face2face",
    label: "Face-to-Face",
    icon: EmojiPeople,
  },
  {
    value: "other",
    label: "Other",
  },
];

export const RETURN_MESSAGES = {
  invalid_token: "Invalid token",
  unauthorised: "Unauthorised",
  ok: "OK",
  success: "Success",
  failed: "Failed",
  invalid_data: "Invalid data",
  error: "Error occurred",
  no_records: "No records found",
  no_device: "No device found",
  token_expired: "Token Expired",
  password_renewal: "Renew password",
  user_not_found: "User Not Found",
  incorrect_old_password: "Old password is incorrect",
};

const normalizeOrderSerialValue = (value) =>
  value === undefined || value === null ? "" : value.toString().toLowerCase();

const isTruthyOrderSerialNoPreallocation = (value) => {
  if (value === undefined || value === null || value === "") {
    return false;
  }
  if (typeof value === "string") {
    return !["0", "false", "no"].includes(value.toLowerCase());
  }
  return value === true || Number(value) > 0;
};

export const isLegacyOrderSerialPreallocationItem = (item) => {
  const sku = normalizeOrderSerialValue(item?.sku);
  return (
    sku.includes("ctn_ec_w") ||
    sku.includes("ctn_ec_g") ||
    sku.includes("_ec_w_") ||
    sku.includes("_ec_g_")
  );
};

export const itemRequiresOrderSerialNoPreallocation = (item) => {
  if (!item || item.type === "service") {
    return false;
  }
  const preallocation = item.DeviceProfile?.orderSerialNoPreallocation;
  if (preallocation !== undefined && preallocation !== null) {
    return isTruthyOrderSerialNoPreallocation(preallocation);
  }
  return isLegacyOrderSerialPreallocationItem(item);
};

export const getOrderSerialAllocationColor = (item) => {
  const text = normalizeOrderSerialValue(
    [item?.color, item?.name, item?.sku].filter(Boolean).join(" "),
  );
  if (text.includes("grey") || text.includes("_g_")) {
    return "Grey";
  }
  if (text.includes("white") || text.includes("_w_")) {
    return "White";
  }
};

export const getOrderSerialDeviceProfileId = (item) =>
  item?.DeviceProfileId || item?.DeviceProfile?.id;

const getOrderSerialStockItemId = (item) => item?.StockItemId || item?.id;

export const getOrderSerialSearchValue = (item) => {
  if (item?.DeviceProfile?.prefix) {
    return item.DeviceProfile.prefix.toLowerCase();
  }
  if (isLegacyOrderSerialPreallocationItem(item)) {
    return "ec";
  }
  return "";
};

const isECabinOrderSerialItem = (item) =>
  isLegacyOrderSerialPreallocationItem(item) ||
  normalizeOrderSerialValue(item?.DeviceProfile?.prefix).startsWith("ec");

export const getOrderSerialDeviceSearchRestrictions = (
  item,
  { hideSecondClass = false, hide3Module = false } = {},
) => {
  const color = getOrderSerialAllocationColor(item);
  const DeviceProfileId = getOrderSerialDeviceProfileId(item);
  return {
    lcState: "ready",
    OrderId: null,
    lcLocation: "mailhouse",
    ...(color ? { color } : {}),
    ...(DeviceProfileId ? { DeviceProfileId } : {}),
    ...(hideSecondClass && isECabinOrderSerialItem(item)
      ? { hideSecondClass: true }
      : {}),
    ...(hide3Module && isECabinOrderSerialItem(item)
      ? { hide3Module: true }
      : {}),
  };
};

export const allocationMatchesOrderSerialItem = (allocation, item) => {
  if (!allocation || !item) {
    return false;
  }
  const itemStockItemId = getOrderSerialStockItemId(item);
  const allocationStockItemId = getOrderSerialStockItemId(allocation);
  if (itemStockItemId && allocationStockItemId) {
    return itemStockItemId.toString() === allocationStockItemId.toString();
  }
  const color = getOrderSerialAllocationColor(item);
  if (
    color &&
    normalizeOrderSerialValue(allocation.color) !==
      normalizeOrderSerialValue(color)
  ) {
    return false;
  }
  const itemProfileId = getOrderSerialDeviceProfileId(item);
  const allocationProfileId =
    allocation.DeviceProfileId || allocation.DeviceProfile?.id;
  if (itemProfileId && allocationProfileId) {
    return itemProfileId.toString() === allocationProfileId.toString();
  }
  const prefix = item?.DeviceProfile?.prefix;
  if (
    prefix &&
    normalizeOrderSerialValue(allocation.serialNumber).startsWith(
      normalizeOrderSerialValue(prefix),
    )
  ) {
    return true;
  }
  if (
    isLegacyOrderSerialPreallocationItem(item) &&
    normalizeOrderSerialValue(allocation.serialNumber).includes("ec2")
  ) {
    return true;
  }
  const allocationProfileName = normalizeOrderSerialValue(
    allocation.DeviceProfile?.name,
  );
  return (
    !!allocationProfileName &&
    normalizeOrderSerialValue(item.name).includes(allocationProfileName)
  );
};

export const getOrderSerialAllocationsForItem = (allocations, item) =>
  (allocations || []).filter((allocation) =>
    allocationMatchesOrderSerialItem(allocation, item),
  );

export const getMissingOrderSerialAllocationCount = (item, allocations) => {
  if (!itemRequiresOrderSerialNoPreallocation(item)) {
    return 0;
  }
  const count = Number(item.count) || 0;
  return Math.max(
    count - getOrderSerialAllocationsForItem(allocations, item).length,
    0,
  );
};

export const orderHasMissingSerialNoPreallocation = (order) =>
  (order?.genericDevices || []).some(
    (item) => getMissingOrderSerialAllocationCount(item, order?.Devices) > 0,
  );

const orderSerialNoPreallocationLabelDisabledStates = [
  "cancelled",
  "delivered",
];

export const shouldShowOrderSerialNoPreallocationLabel = (order) =>
  !orderSerialNoPreallocationLabelDisabledStates.includes(
    order?.paymentStatus,
  ) && orderHasMissingSerialNoPreallocation(order);

export const shipmentStatus = [
  { title: "Waiting for Pickup", value: "waiting" },
  { title: "In Transit", value: "transit", color: "#ccffcc" },
  { title: "Delivered", value: "delivered", color: "limegreen" },
  { title: "Cancelled", value: "cancelled", color: "lightgrey" },
  { title: "Return to Origin", value: "returned", color: "red" },
];

// This is now deprecated, all the profiles are refrenced from the API
export const deviceProfiles = [
  {
    name: CRYOCABIN,
    prefix: "CTN",
    serialNumberFormat: {
      regex: "^CTN17.*$",
      length: 9,
    },
    image: CryoCabinImage,
  },
  {
    name: ECABIN,
    prefix: "EC2",
    serialNumberFormat: {
      regex: "^EC22.*$",
      length: 8,
    },
    image: ECabinImage,
  },
  {
    name: VETCRYO,
    prefix: "VC",
    serialNumberFormat: {
      regex: "^VC18.*$",
      length: 8,
    },
    image: VetCryoImage,
  },
  {
    name: XTONE,
    prefix: "XT",
    serialNumberFormat: {
      regex: "^XT21.*$",
      length: 8,
    },
    image: XToneImage,
  },
  {
    name: XCRYO,
    prefix: "XC",
    serialNumberFormat: {
      regex: "^XC18.*$",
      length: 8,
    },
    image: XCryoImage,
  },
  {
    name: EQCRYO,
    prefix: "EQ", // NOTE: Some EQ devices have H prefix!
    serialNumberFormat: {
      regex: "^EQ.*$",
      length: 8,
    },
    image: EQCryoImage,
  },

  {
    name: "OXYPRO VS1",
    prefix: "OPVS1",
    serialNumberFormat: {
      regex: "^OPVS1.*$",
      length: 12,
    },
    image: "",
  },
  {
    name: "OXYPRO VH1",
    prefix: "OPVH1",
    serialNumberFormat: {
      regex: "^OPVH1.*$",
      length: 12,
    },
    image: "",
  },
  {
    name: "OXYPRO VH3",
    prefix: "OPVH3",
    serialNumberFormat: {
      regex: "^OPVH3.*$",
      length: 12,
    },
    image: "",
  },
  {
    name: "OXYPRO VH4",
    prefix: "OPVH4",
    serialNumberFormat: {
      regex: "^OPVH4.*$",
      length: 12,
    },
    image: "",
  },
  {
    name: "OXYPRO HH1",
    prefix: "OP2",
    serialNumberFormat: {
      regex: "^OP2.*$",
      length: 9,
    },
    image: "",
  },
  {
    name: LEDPRO,
    prefix: "RLT",
    serialNumberFormat: {
      regex: "^RLT.*$",
      length: 9,
    },
    image: "",
  },
  {
    name: QUATTRO,
    prefix: "Q18",
    serialNumberFormat: {
      regex: "^Q18.*$",
      length: 7,
    },
    image: "",
  },
];

export const paymentStates = [
  {
    label: "Awaiting for VAT confirmation",
    value: "waiting",
    color: "#ff6363ff",
  },
  {
    label: "Invoiced",
    value: "invoiced",
  },
  {
    label: "Deposit Completed",
    value: "deposit",
    color: "#ffbf00",
  },
  {
    label: "Payment Fully Completed",
    value: "completed",
    color: "#ccffcc",
  },
  {
    label: "In Transit",
    value: "transit",
    color: "#00ff00",
  },
  {
    label: "Items Delivered",
    value: "delivered",
    color: "limegreen",
  },
  {
    label: "Cancelled",
    value: "cancelled",
    color: "lightgrey",
  },
];

export const shippingMethods = [
  {
    label: "Air Freight",
    value: "air",
  },
  {
    label: "Sea Freight",
    value: "sea",
  },
  {
    label: "Rail Freight",
    value: "rail",
  },
  {
    label: "Road Freight",
    value: "road",
  },
  {
    label: "Courier",
    value: "courier",
  },
  {
    label: "White Glove",
    value: "white_glove",
  },
  {
    label: "Other",
    value: "other",
  },
];

function exampleFromRegex(regexString) {
  return regexString
    .replace(/^\^/, "")
    .replace(/\$$/, "")
    .replace(/(\\d|\[0-9\])\{(\d+)\}/g, (_, __, count) =>
      "0".repeat(Number(count)),
    )
    .replace(/(\\d|\[0-9\])\+/g, "0")
    .replace(/(\\d|\[0-9\])\*/g, "")
    .replace(/(\\d|\[0-9\])\?/g, "0")
    .replace(/\\d|\[0-9\]/g, "0");
}

export const checkNewSerialNumber = (data, profiles, t) => {
  data = data.replace(" ", "");
  if (profiles && profiles.length) {
    for (let index = 0; index < profiles.length; index++) {
      const element = profiles[index];
      if (
        data.length < element.prefix.length ||
        data.toUpperCase().substring(0, element.prefix.length) !==
          element.prefix
      ) {
        continue;
      }
      if (!element.serialNumberFormat?.regex) {
        continue;
      }
      const regex = new RegExp(element.serialNumberFormat.regex);
      if (regex.test(data.toUpperCase())) {
        return;
      } else {
        return (
          element.name +
          (t
            ? " " + t("newDeviceDialog.incorrectSerialNumberFormat")
            : " Incorrect Serial Number format! Correct: ") +
          exampleFromRegex(element.serialNumberFormat.regex)
        );
      }
    }
  }
  // Old validation
  var val;
  if (data.toLowerCase()[0] === "q") {
    val = parseInt(data.toLowerCase().replace("q", ""));
    if (data.length === 7 && val > 180000 && val < 190000) {
      return;
    }
    return "Quattro Serial number should be in format of Q180000";
  }
  if (data.toLowerCase().includes("xc")) {
    // XCryo
    val = parseInt(data.toLowerCase().replace("xc", ""));
    if (data.length === 8 && val > 180000 && val < 190000) {
      return;
    }
    return "XCryo Serial number should be in format of XC180000";
  }
  if (data.toLowerCase().includes("xt")) {
    // XTone
    val = parseInt(data.toLowerCase().replace("xt", ""));
    if (data.length >= 8 && val > 210000 && val < 2200000) {
      return;
    }
    return "XTone Serial number should be in format of XT2100000";
  }
  if (data.length < 8) {
    return "Incorrect Serial Number Format!";
  }
};

export const checkValidClientObject = (val) => {
  var x = false;
  if (!val) {
    return false;
  }
  try {
    val = JSON.parse(val);
  } catch (error) {}
  Object.values(val).forEach((v) => {
    if (v) {
      x = true;
    }
  });
  return x;
};

export const ticketStates = [
  {
    label: "New",
    value: "new",
  },
  {
    label: "In progress",
    value: "progress",
  },
  {
    label: "Resolved",
    value: "resolved",
  },
  {
    label: "Stale",
    value: "stale",
  },
];

export const ticketListRowStyle = (data, index) => {
  var obj = { cursor: "pointer" };
  if (data.priority === TICKET_PRIORITIES["HIGH"]) {
    return { ...obj, backgroundColor: "lightcoral" };
  }
  if (data.priority === TICKET_PRIORITIES["NORMAL"]) {
    return { ...obj, backgroundColor: "lightyellow" };
  }
  if (data.priority === TICKET_PRIORITIES["LOW"]) {
    return { ...obj, backgroundColor: "lightblue" };
  }
  if (Object.keys(obj).length === 1 && index % 2 === 0) {
    obj.backgroundColor = "rgba(245, 245, 245, 1)";
  }
  return obj;
};

export const lifeCycleStates = [
  {
    label: "In Production",
    value: "production",
  },
  {
    label: "Ready for Shipment",
    value: "ready",
  },
  {
    label: "Demo",
    value: "demo",
  },
  {
    label: "Dispatched to Client",
    value: "dispatched",
  },
  {
    label: "In Maintenance",
    value: "maintenance",
  },
  {
    label: "Decommissioned",
    value: "decommissioned",
  },
  {
    label: "Missing",
    value: "missing",
  },
  {
    label: "In Storage",
    value: "storaged",
  },
];

export const getLCState = (data) => {
  var d = "";
  lifeCycleStates.forEach((val) => {
    if (val.value === data) {
      d = val.label;
    }
  });
  return d;
};

export const getLCLocation = (data) => {
  var d = "";
  var war = getWarehouses(null, null, null, true) || warehouseLocation;
  war.forEach((val) => {
    if (val.value === data) {
      d = val.label;
    }
  });
  return d;
};

/**
 * Fetches the available warehouses from the API
 * and stores the data to session storage
 *
 *
 * @param {function} setter Setter function for the received data
 * @param {function} dispatch useDispatch Hook
 * @param {boolean} refresh forces the function reload the data from the server
 * @param {boolean} only_local only fetch and return from the sessionStorage (if exists)
 */
export const getWarehouses = (setter, dispatch, refresh, only_local) => {
  var warehouses = sessionStorage.getItem("warehouses") || null;
  if (warehouses) {
    warehouses = JSON.parse(warehouses);
  }
  if (only_local && warehouses) {
    return warehouses || null;
  }
  if (warehouses && warehouses.length && !refresh && setter) {
    setter(warehouses.sort((a, b) => (a.label < b.label ? -1 : 1)));
    return;
  }
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: getToken(),
    }),
  };
  fetch(server + "/get_warehouses", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      if (dispatch) {
        requestErrorHandler(result, dispatch);
      }
      if (result.warehouses) {
        var w = result.warehouses.sort((a, b) => (a.label < b.label ? -1 : 1));
        sessionStorage.setItem("warehouses", JSON.stringify(w));
        if (setter) {
          setter(w);
        }
      }
    });
};

/**
 * Fetches the available deviceProfiles from the API
 * and stores the data to session storage
 *
 *
 * @param {function} setter Setter function for the received data
 * @param {function} dispatch useDispatch Hook
 * @param {boolean} refresh forces the function reload the data from the server
 * @param {boolean} only_local only fetch and return from the sessionStorage (if the loacl storage exists)
 */
export const getDeviceProfiles = (setter, dispatch, refresh, only_local) => {
  var deviceProfiles = sessionStorage.getItem("deviceProfiles") || null;
  if (deviceProfiles) {
    deviceProfiles = JSON.parse(deviceProfiles);
  }
  if (only_local && deviceProfiles) {
    return deviceProfiles || null;
  }
  if (deviceProfiles && deviceProfiles.length && !refresh && setter) {
    setter(deviceProfiles.sort((a, b) => (a.label < b.label ? -1 : 1)));
    return;
  }
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: getToken(),
    }),
  };
  fetch(server + "/get_device_profiles", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      if (dispatch) {
        requestErrorHandler(result, dispatch);
      }
      if (result.deviceprofiles) {
        var w = result.deviceprofiles.sort((a, b) =>
          a.label < b.label ? -1 : 1,
        );
        sessionStorage.setItem("deviceProfiles", JSON.stringify(w));
        if (setter) {
          setter(w);
        }
      }
    });
};

export const getInvoiceIssuer = (invoiceIssuers, value) => {
  if (!value || !Array.isArray(invoiceIssuers)) {
    return undefined;
  }
  return invoiceIssuers.find((issuer) => issuer?.name === value);
};

export const getInvoiceIssuerData = (invoiceIssuers, value, context) => {
  var values = getInvoiceIssuer(invoiceIssuers, value)?.data;
  if (context === "shipment" && values) {
    const bankvals = ["bank", "accountName", "vat"];
    const keys = Object.keys(values).filter(
      (f) => !bankvals.find((d) => f.includes(d)),
    );
    var val = {};
    for (let index = 0; index < keys.length; index++) {
      const element = keys[index];
      val = { ...val, [element]: values[element] };
    }
    return val;
  }
  return values;
};

export const getInvoiceIssuerOptions = (invoiceIssuers) =>
  [...(Array.isArray(invoiceIssuers) ? invoiceIssuers : [])].sort((a, b) =>
    (a?.data?.name || a?.name || "") < (b?.data?.name || b?.name || "")
      ? -1
      : 1,
  );

export const invoiceIssuerMatchesValue = (value, selectedValue) => {
  if (!selectedValue) {
    return true;
  }
  if (!value) {
    return false;
  }
  return value === selectedValue;
};

/**
 * Fetches the available invoice issuers from the API
 * and stores the data to session storage.
 *
 * Backend rows are shaped as { id, name, data }. The name is the identifier.
 *
 * @param {function} setter Setter function for the received data
 * @param {function} dispatch useDispatch Hook
 * @param {boolean} refresh forces the function reload the data from the server
 * @param {boolean} only_local only fetch and return from the sessionStorage (if exists)
 */
export const getInvoiceIssuers = (setter, dispatch, refresh, only_local) => {
  var invoiceIssuers = sessionStorage.getItem("invoiceIssuers") || null;
  if (invoiceIssuers) {
    invoiceIssuers = JSON.parse(invoiceIssuers);
  }
  if (invoiceIssuers && !Array.isArray(invoiceIssuers)) {
    sessionStorage.removeItem("invoiceIssuers");
    invoiceIssuers = null;
  }
  if (only_local && invoiceIssuers) {
    return invoiceIssuers || null;
  }
  if (
    invoiceIssuers &&
    Object.keys(invoiceIssuers).length &&
    !refresh &&
    setter
  ) {
    setter(invoiceIssuers);
    return;
  }
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: getToken(),
    }),
  };
  fetch(server + "/get_invoice_issuers", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      if (dispatch) {
        requestErrorHandler(result, dispatch);
      }
      if (result.invoiceIssuers) {
        sessionStorage.setItem(
          "invoiceIssuers",
          JSON.stringify(result.invoiceIssuers),
        );
        if (setter) {
          setter(result.invoiceIssuers);
        }
      }
    });
};

/**
 * Fetches the required data packages from the server
 */
export const getSystemDependencies = () => {
  getWarehouses(null, null, false, true);
  getDeviceProfiles(null, null, false, true);
  getInvoiceIssuers(null, null, false, true);
};

export const warehouseLocation = [
  {
    label: "Reimax Klaukkala",
    value: "reimax",
  },
  {
    label: "Mailhouse Kerava",
    value: "mailhouse",
  },
  {
    label: "CTN Finland",
    value: "vantaa",
    editableStock: true,
  },
  {
    label: "CTN Estonia",
    value: "estonia",
    editableStock: true,
  },
  {
    label: "CTN Spain",
    value: "spain",
    editableStock: true,
  },
];

/**
 *
 * Expects LifeCycleStates Array Object
 * Uses id as the identifier for the latest LCS
 * @param {Array} data
 */
export const getLatestLifeCycleState = (data) => {
  if (!data) {
    return data;
  }
  if (!data.length) {
    return data;
  }
  return data.reduce(
    (prev, current) => (prev.id > current.id ? prev : current),
    1,
  );
};

export const getWarrantyStatusText = (deviceData, t) => {
  const formatLocalDate = (date) => {
    if (!date || Number.isNaN(date.getTime())) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const parseLocalDate = (value) => {
    if (!value) {
      return null;
    }
    const parts = value.split("-");
    if (parts.length !== 3) {
      return null;
    }
    const year = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const day = Number(parts[2]);
    const parsed = new Date(year, month, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  const getExpiryDate = (activeFrom, durationYears) => {
    if (!activeFrom || !durationYears) {
      return null;
    }
    const base = parseLocalDate(activeFrom);
    if (!base) {
      return null;
    }
    const expiry = new Date(base);
    expiry.setFullYear(expiry.getFullYear() + Number(durationYears));
    expiry.setHours(0, 0, 0, 0);
    return expiry;
  };

  const warrantyItems = deviceData?.WarrantyItems || [];
  const latestLcs = getLatestLifeCycleState(deviceData?.LifeCycleStates);
  const shouldShowDefaultItem =
    !warrantyItems.length && latestLcs?.state === "dispatched";
  const defaultItem = shouldShowDefaultItem
    ? {
        id: "default",
        name: t("warranty.defaultItem"),
        activeFrom: latestLcs?.createdAt
          ? new Date(latestLcs.createdAt).toISOString().slice(0, 10)
          : null,
        duration: 3,
        warrantyVoid: 0,
      }
    : null;
  const itemsToCheck = warrantyItems.length
    ? warrantyItems
    : defaultItem
      ? [defaultItem]
      : [];

  if (!itemsToCheck.length) {
    return t("deviceDetails.warrantyStatusUnknown");
  }

  const todayMs = new Date().setHours(0, 0, 0, 0);
  let hasVoid = false;
  let latestValidExpiryMs = null;
  let latestExpiredExpiryMs = null;
  let latestValidName = null;
  let latestExpiredName = null;
  let voidName = null;

  itemsToCheck.forEach((item) => {
    const itemName =
      item?.id === "default"
        ? "AutoGenerated"
        : item?.name || t("warranty.defaultItem");
    if (item?.warrantyVoid) {
      hasVoid = true;
      if (!voidName) {
        voidName = itemName;
      }
      return;
    }
    const expiryDate = getExpiryDate(item?.activeFrom, item?.duration);
    const expiryMs = expiryDate ? expiryDate.getTime() : null;

    if (expiryMs === null) {
      return;
    }
    if (expiryMs > todayMs) {
      if (latestValidExpiryMs === null || expiryMs > latestValidExpiryMs) {
        latestValidExpiryMs = expiryMs;
        latestValidName = itemName;
      }
      return;
    }
    if (latestExpiredExpiryMs === null || expiryMs > latestExpiredExpiryMs) {
      latestExpiredExpiryMs = expiryMs;
      latestExpiredName = itemName;
    }
  });

  if (latestValidExpiryMs !== null) {
    const validUntil = formatLocalDate(new Date(latestValidExpiryMs));
    return `${t("deviceDetails.warrantyStatusValidUntil", { date: validUntil })} (${latestValidName || t("warranty.defaultItem")})`;
  }
  if (hasVoid) {
    return `${t("deviceDetails.warrantyStatusVoid")} (${voidName || t("warranty.defaultItem")})`;
  }
  if (latestExpiredExpiryMs !== null) {
    const expiredOn = formatLocalDate(new Date(latestExpiredExpiryMs));
    return `${t("deviceDetails.warrantyStatusExpiredOn", { date: expiredOn })} (${latestExpiredName || t("warranty.defaultItem")})`;
  }
  return t("deviceDetails.warrantyStatusUnknown");
};

export const resolveTransferLocation = (element) => {
  if (!element) {
    return element;
  }
  if (
    element.state === "demo" &&
    element.location === "client" &&
    !checkValidClientObject(element.clientInfo)
  ) {
    return "car";
  }
  return element.location;
};

export const transferStates = ["return", "demo", "sold"];

export const clientInfoOptions = [
  { value: "contactName", label: "Contact Name" },
  { value: "companyName", label: "Company Name" },
  { value: "country", label: "Country" },
];

/**
 *
 * @param {Array} data
 * @param {String} device
 * @param {Number} session_type
 * @returns - Formatted array
 */

export const formatChartData = (data, device, session_type, exclude = []) => {
  var retdata = [];
  data.forEach((element, idx) => {
    var obj = {};
    Object.keys(element).forEach((k) => {
      if (
        k.includes("temp") ||
        k.includes("activeDevices") ||
        k.includes("humidity")
      ) {
        if (element[k] !== null && !exclude.includes(k)) {
          Object.assign(obj, { [k]: element[k] });
        }
      } else if (k.includes("pressure") && !exclude.includes(k)) {
        if (element.pressure !== null) {
          Object.assign(obj, { pressure: element.pressure * 10 });
        }
      }
      if (device === ECABIN && session_type === 1) {
        Object.assign(obj, { timeStamp: idx * 5 });
      } else {
        Object.assign(obj, { timeStamp: idx });
      }
    });
    retdata.push(obj);
  });
  return retdata;
};

export const getLogoImage = (data) => {
  if (!data) {
    return;
  }
  var arr = getDeviceProfiles(null, null, null, true) || [];
  return arr.find((f) => getDeviceType(data) === f.name)?.imageLink || "";
};

export const hslToHex = (h, s, l) => {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};
/**
 * This function can resolve the keynames for each devices as the temperature slots have different meaning in different devices
 * @param {String} keyname
 * @param {String} device
 * @returns {String}
 */

export const getMeasurementName = (keyname, device) => {
  if (keyname.includes("timeStamp")) return "Time";
  if (keyname.includes("humidity")) return "Humidity";
  if (keyname.includes("pressure")) return "Pressure";
  if (device === ECABIN) {
    if (keyname.includes("temp")) {
      var i = getIntegerFromSpelledNumber(keyname.replace("temp", ""));
      if (i <= 6) {
        return "Camera" + i;
      }
      if (i === 7) return "CabinTemp";
      if (i === 8) return "EvaporatorLeftTemp";
      if (i === 9) return "EvaporatorRightTemp";
      if (i === 10) return "CameraAmbientTemp";
      if (i === 11) return "RoomAmbientTemp";
    }
  }
  if (device === CRYOCABIN) {
    if (keyname.includes("tempOne")) return "VortexOut";
    if (keyname.includes("tempTwo")) return "VortexIn";
    if (keyname.includes("tempThree")) return "FloodSensor";
  }
  if (device === XCRYO) {
    if (keyname.includes("tempOne")) return "Evaporator";
    if (keyname.includes("tempTwo")) return "Compressor";
  }
  if (device === EQCRYO) {
    if (keyname.includes("tempOne")) return "LeftVortexOut";
    if (keyname.includes("tempTwo")) return "RightVortexOut";
    if (keyname.includes("tempThree")) return "LeftVortexIn";
    if (keyname.includes("tempFour")) return "RightVortexIn";
    if (keyname.includes("tempFive")) return "LeftFloodSensor";
    if (keyname.includes("tempSix")) return "RightFloodSensor";
  }
  return keyname;
};

export const getSessionType = (device, type) => {
  if (device === CRYOCABIN || device === EQCRYO || device === ECABIN) {
    switch (type) {
      case 1:
        return "PRECOOL";
      case 2:
        return "SESSION";
      case 11:
        return "TEST SEQUENCE";
      default:
        break;
    }
  } else if (device === XCRYO) {
    switch (type) {
      case 1:
        return "PRECOOL";
      case 2:
        return "SPOT";
      case 3:
        return "FACE";
      case 4:
        return "PRO";
      case 5:
        return "CUSTOM";
      case 6:
        return "CRYOLIPO";
      default:
        break;
    }
  }
  return "";
};

/**
 * Returns the consumption reference value
 * @param {String} type
 * @returns Integer
 */
export const getConsumptionRefrence = (type) => {
  switch (type) {
    case CRYOCABIN:
      return 5;
    case EQCRYO:
      return 15;
    case VETCRYO:
      return 10;
    default:
      return 5;
  }
};

/**
 * Takes Serial Number
 * @param {String} data
 * @returns DeviceType as String
 */

export const getDeviceType = (data) => {
  if (!data) {
    return "";
  }
  var arr = getDeviceProfiles(null, null, null, true) || [];
  return (
    arr.find(
      (f) =>
        data.includes(f.prefix) ||
        (f.name === EQCRYO && data[0] === "H") ||
        (f.name === QUATTRO && data[0] === "Q") ||
        (f.name === ECABIN && data.includes("compillerrasp")),
    )?.name || ""
  );
};

export const DEVICE_SEARCH_ID = "device_search";
export const STOCK_SEARCH_ID = "stock_search";

export const saveToStorage = (_id, _value) => {
  sessionStorage.setItem(_id, _value);
};

export const getFromStorage = (_id) => {
  return sessionStorage.getItem(_id) || null;
};

function b64e(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode("0x" + p1);
    }),
  );
}

function b64d(str) {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return "%" + c.charCodeAt(0).toString(16);
      })
      .join(""),
  );
}

// return the user data from the session storage
export const getUser = () => {
  try {
    var myObject = sessionStorage.getItem("user");
    if (!myObject) {
      return null;
    }
    return (
      b64d(myObject) &&
      JSON.parse(b64d(myObject), function (key, value) {
        if (key === "permissionlevel" || key === "userId") {
          return parseInt(b64d(this[key]));
        }
        return key ? b64d(this[key]) : this[key];
      })
    );
  } catch (error) {
    removeUserSession();
    return null;
  }
};

// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

// set the token and user from the session storage
export const setUserSession = (token, user) => {
  sessionStorage.setItem("token", token);
  var newObject = {};
  if (!user) {
    return;
  }
  Object.keys(user).forEach(function (value, index) {
    newObject[value] = b64e(user[value]);
  });
  sessionStorage.setItem("user", b64e(JSON.stringify(newObject)));
  // sessionStorage.setItemHash("user", JSON.stringify(user));
};

export const setUserLanguage = (lang) => {
  localStorage.setItem("language", lang);
};

export const getUserLanguage = () => {
  return localStorage.getItem("language");
};

export const checkAdmin = () => {
  return window.location.href.includes("/cpanel");
};

/**
 *
 * @param {Array} requirements list of permissionlevels
 * @returns boolean
 */
export const checkRequiredPermissions = (requirements) => {
  if (requirements && Array.isArray(requirements)) {
    const user = getUser();
    if (!user) {
      return false;
    }
    if (user.permissionlevel === USER_GROUPS.SUPER_USER) {
      return true;
    }
    return requirements.findIndex((o) => o === user.permissionlevel) > -1
      ? true
      : false;
  }
  return false;
};

const SQL_DATETIME_FORMAT = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
const ISO_DATETIME_FORMAT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/i;
const TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

const isEpochTimestamp = (time) =>
  time.trim() !== "" && Number.isFinite(Number(time));

function formatTimeStamp(time) {
  const value = time instanceof Date ? time.toISOString() : String(time);
  if (isEpochTimestamp(value)) {
    let timestamp = Number(value);
    if (timestamp < 1000000000 * 1000) {
      timestamp = timestamp * 1000;
    }
    return new Date(timestamp).toISOString();
  } else if (SQL_DATETIME_FORMAT.test(value)) {
    return value.replace(" ", "T") + ".000Z";
  }
  return value;
}

const normalizeIsoTimezone = (time) => {
  if (!ISO_DATETIME_FORMAT.test(time) || TIMEZONE_SUFFIX.test(time)) {
    return time;
  }
  return `${time}${time.includes(".") ? "" : ".000"}Z`;
};

export const formatTimeWithTZOffset = (data) => {
  if (!data) {
    return data;
  }
  const value = data instanceof Date ? data.toISOString() : String(data);
  if (SQL_DATETIME_FORMAT.test(value)) {
    return value;
  }

  if (!isEpochTimestamp(value) && !ISO_DATETIME_FORMAT.test(value)) {
    return data;
  }

  const timestamp = normalizeIsoTimezone(formatTimeStamp(data));
  const parsedTimestamp = Date.parse(timestamp);
  if (isNaN(parsedTimestamp)) {
    return data;
  }

  var val = new Date(
    parsedTimestamp - new Date(parsedTimestamp).getTimezoneOffset() * 60 * 1000,
  )
    .toISOString()
    .substring(0, 19)
    .replace("T", " ");
  return val;
};
export const getTimestampWithoutOffset = (data) => {
  return new Date(Date.parse(data.replace(" ", "T")))
    .toISOString()
    .replace("T", " ")
    .substring(0, 19);
};

export const validateDateType = (data, format) => {
  if (!data) {
    return false;
  } else {
    if (format === "date") {
      return data.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    } else {
      return data.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/);
    }
  }
};

export const getLastParameter = () => {
  var data = window.location.href;
  var arr = data.split("/");
  return arr[arr.length - 1];
};

export const formatGoogleDriveMediaLink = (data, type) => {
  if (data && data.includes("drive.google.com")) {
    if (type === "video") {
      // https://drive.google.com/file/d/1i1X8IkOp0C_JlKsbvhgVaETn53XrQ7Ng/view?usp=drive_link
      // https://drive.google.com/file/d/1i1X8IkOp0C_JlKsbvhgVaETn53XrQ7Ng/preview
      return data.split("/view")[0] + "/preview";
    }
    // var st = "https://drive.google.com/uc?export=view&id=";
    var st = "https://lh3.google.com/u/0/d/";
    data = data.split("/d/");
    st = st + data[1].split("/view")[0];
    data = st;
    return data;
  }
  // if (data && data.includes(AWS_IMAGE_HOSTING_TAG)) {
  //   const requestOptions = {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       token: getToken(),
  //       imageId: data,
  //     }),
  //   };
  //   data = await fetch(server + "/get_s3_image", requestOptions)
  //     .then((res) => res.json())
  //     .then((result) => {
  //       if (result.image) {
  //         return result.image;
  //       }
  //       return "";
  //     });
  //   return data;
  // }
  return data;
};

export const getIntegerFromSpelledNumber = (data) => {
  switch (data) {
    case "One":
      return 1;
    case "Two":
      return 2;
    case "Three":
      return 3;
    case "Four":
      return 4;
    case "Five":
      return 5;
    case "Six":
      return 6;
    case "Seven":
      return 7;
    case "Eight":
      return 8;
    case "Nine":
      return 9;
    case "Ten":
      return 10;
    case "Eleven":
      return 11;
    default:
      break;
  }
};

export const numberToWord = (data) => {
  switch (data) {
    case 1:
      return "One";
    case 2:
      return "Two";
    case 3:
      return "Three";
    case 4:
      return "Four";
    case 5:
      return "Five";
    case 6:
      return "Six";
    case 7:
      return "Seven";
    case 8:
      return "Eight";
    case 9:
      return "Nine";
    case 10:
      return "Ten";
    case 11:
      return "Eleven";
    default:
      break;
  }
};

/**
 * Alert formats
 * - First digit tells the general problem
 * - Second digit tells the detail
 *
 * - Example Duration of precool is too long, alert code 11
 * - Example Duration of session is too long? alert code 12
 * - Example Temp sensor 3 is broken alertcode 23
 *
 */
export const ALERT_TYPES = {
  duration: 1,
  broken_sensor: 2,
  failed_session: 3,
  failed_compressor: 4,
  device_transferred: 98,
  checklist_uploaded: 99,
};

export const skipAlertOptions = [
  {
    value: "long_precool",
    label: "Long Precool",
    type: ALERT_TYPES.duration,
  },
  {
    value: "failed_sensor",
    label: "Failed Sensor",
    type: ALERT_TYPES.broken_sensor,
  },
  {
    value: "failed_session",
    label: "Failed Session",
    type: ALERT_TYPES.failed_session,
  },
  {
    value: "failed_compressor",
    label: "Failed Compressor",
    type: ALERT_TYPES.failed_compressor,
  },
];
export const sensorOptions = [
  { value: 1, label: "Camera 1" },
  { value: 2, label: "Camera 2" },
  { value: 3, label: "Camera 3" },
  { value: 4, label: "Camera 4" },
  { value: 5, label: "Camera 5" },
  { value: 6, label: "Camera 6" },
  { value: 7, label: "Cabin Temp" },
  { value: 8, label: "Evaporator Left" },
  { value: 9, label: "Evaporator Right" },
  { value: 10, label: "Camera Ambient" },
];

/**
 * - Accepts object containing alertType
 * - Accept string which is the alertType
 * - Accepts number which is the alertType
 * @param {object} element
 * @param {string} element
 * @param {number} element
 * @returns {string}
 */
export const resolveAlertType = (element) => {
  if (typeof element === "string" || typeof element === "number") {
    return skipAlertOptions.find((o) => o.type === parseInt((element + "")[0]))
      .label;
  }
  return (
    skipAlertOptions.find(
      (o) => o.type === parseInt((element.alertType + "")[0]),
    )?.label ?? ""
  );
};

/**
 * - Logs the result if in development
 * - Shows popup message on error
 * - Checks the validity of the post request against known return messages
 * @param {json} result JSON object
 * @param {function} dispatch useDispatch function
 * @param {object} history useHistory object OPTIONAL
 */

export const requestErrorHandler = (result, dispatch, history) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(window.location.href, result);
  }
  // No errors to be handled
  if (!result.error) {
    return;
  }
  dispatch(showPopupSnackbar(result));
  switch (result.message) {
    case RETURN_MESSAGES.token_expired:
      // Logout the user if the token is invalid
      setTimeout(() => {
        removeUserSession();
        window.location.reload();
      }, 3000);
      break;
    case RETURN_MESSAGES.password_renewal:
      // If the password need to be renewed
      if (history) {
        history.push("/renew_password");
      }
      break;
    default:
      break;
  }
};

const parseFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) {
    return null;
  }
  // RFC 5987 format first: filename*=UTF-8''...
  let match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (match && match[1]) {
    try {
      return decodeURIComponent(match[1].trim().replace(/["']/g, ""));
    } catch (error) {
      return match[1].trim().replace(/["']/g, "");
    }
  }
  // Fallback: filename="..."
  match = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (match && match[1]) {
    return match[1].trim();
  }
  return null;
};

/**
 * Handles fetch response for endpoints that can return either JSON error payloads
 * or a streamed file download.
 * @param {Response} res fetch response object
 * @param {function} dispatch redux dispatch function
 * @param {string} defaultFilename filename used when response headers do not contain one
 * @param {string} fallbackErrorMessage shown if response fails without json payload
 */
export const handleDownloadFetchResponse = async (
  res,
  dispatch,
  defaultFilename,
  fallbackErrorMessage,
) => {
  const contentType = (res.headers.get("content-type") || "").toLowerCase();

  if (contentType.includes("application/json")) {
    const result = await res.json();
    requestErrorHandler(result, dispatch);
    return result;
  }

  if (!res.ok) {
    dispatch(
      showPopupSnackbar({
        error: true,
        message: fallbackErrorMessage || RETURN_MESSAGES.error,
      }),
    );
    return;
  }

  const blob = await res.blob();
  const contentDisposition = res.headers.get("content-disposition") || "";
  const resolvedFilename =
    parseFilenameFromContentDisposition(contentDisposition) ||
    defaultFilename ||
    "download";

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = resolvedFilename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const contactObjectSkeleton = {
  contactName: "",
  companyName: "",
  companyAdditionalInfo: "",
  contactAdditionalInfo: "",
  location: "",
  contactId: null,
  companyId: null,
};

/**
 * Reads LCS and returns formatted JSON object
 *
 * @param {JSON} data LCS object
 * @returns {JSON}
 */

export const readClientDataFromLCS = (data) => {
  if (!data || typeof data === "string") {
    return;
  }
  var latest_lcs;
  // Check for formatted data
  if (data.LifeCycleStates && data.LifeCycleStates.length) {
    latest_lcs = getLatestLifeCycleState(data.LifeCycleStates);
  } else if (Object.keys(data).find((k) => k === "clientInfoString")) {
    latest_lcs = data;
  } else if (data.state && data.location) {
    latest_lcs = data;
  }
  // Undefined data structure
  if (!latest_lcs) {
    return;
  }
  var contact = { ...contactObjectSkeleton };
  if (latest_lcs.Company) {
    contact.companyId = latest_lcs.Company.id;
    contact.companyName = latest_lcs.Company.name;
    contact.location = latest_lcs.Company.location;
  }
  if (latest_lcs.Contact) {
    contact.contactName = latest_lcs.Contact.name;
    contact.contactId = latest_lcs.Contact.id;
  }
  // Check if all values empty
  if (!Object.values(contact).find((v) => v) && latest_lcs.clientInfo) {
    if (typeof latest_lcs.clientInfo === "string") {
      try {
        latest_lcs.clientInfo = JSON.parse(latest_lcs.clientInfo);
      } catch (error) {}
    }
    try {
      contact.companyName = latest_lcs.clientInfo?.companyName;
      contact.contactName = latest_lcs.clientInfo?.contactName;
      contact.location = latest_lcs.clientInfo?.country;
    } catch (error) {}
  }
  return contact;
};

export const formatContacts = (data) => {
  if (!data) {
    return [];
  }
  var contact = { ...contactObjectSkeleton };
  var arr = [];
  if (data.contacts && data.contacts.length) {
    data.contacts.forEach((element) => {
      var obj = {
        contactName: element.name,
        contactId: element.id,
        ...element.additionalInfo,
      };
      Object.keys(contact).forEach((k) => {
        if (k === "companyAdditionalInfo" && element.Company) {
          obj = { ...obj, ...element.Company.additionalInfo };
        } else if (k.includes("company") && element.Company) {
          obj[k] = element.Company[k.replace("company", "").toLowerCase()];
        } else if (k === "location" && element.Company) {
          obj[k] = element.Company.location;
        }
      });
      arr.push({
        // ...contact,
        ...obj,
      });
    });
  }
  if (data.companies && data.companies.length) {
    data.companies.forEach((element) => {
      var obj = {
        // ...contact,
        companyName: element.name,
        companyId: element.id,
        location: element.location,
        ...element.additionalInfo,
      };
      if (!element.Contacts || !element.Contacts.length) {
        arr.push(JSON.parse(JSON.stringify(obj)));
        return;
      }
      element.Contacts &&
        element.Contacts.forEach((co) => {
          var obj3;
          var obj2 = {
            contactId: co.id,
            contactName: co.name,
            ...co.additionalInfo,
          };
          obj3 = { ...obj, ...obj2 };
          if (!arr.find((o) => shallowEqual(o, obj3))) {
            arr.push(JSON.parse(JSON.stringify(obj3)));
          }
        });
      if (!element.Contacts.length && !arr.find((o) => shallowEqual(o, obj))) {
        arr.push(JSON.parse(JSON.stringify(obj)));
      }
    });
  }
  return arr;
};

/**
 * Expects object with keys contactId, companyId, companyName,contactName and location
 * @param {JSON} data
 * @param {Array<String>} selectedKeys
 * @returns string
 */

export const formatClientInfoString = (data, selectedKeys) => {
  if (!data || !Object.keys(data).length) return "";
  var st;
  var _data;
  if (Object.keys(data).length) {
    if (data.companyId) {
      delete data.companyId;
    }
    if (data.contactId) {
      delete data.contactId;
    }
    if (Object.values(data).every((o) => !o)) {
      return "";
    }
    _data = JSON.parse(JSON.stringify(data));
    if (selectedKeys) {
      Object.keys(data).forEach((k) => {
        selectedKeys.includes(k) || delete _data[k];
      });
    }
    st = Object.values(_data).join(" / ");
    st = st.replace("//", "/");
    if (st[0] === "/") {
      st = st.substring(1, st.length);
    }
    if (st[st.length - 1] === "/") {
      st = st.substring(0, st.length - 1);
    }
    return st;
  }
  var obj = JSON.parse(data);
  if (obj.companyId) {
    delete obj.companyId;
  }
  if (obj.contactId) {
    delete obj.contactId;
  }
  if (Object.values(obj).every((o) => !o)) {
    return "";
  }
  _data = JSON.parse(JSON.stringify(obj));
  if (selectedKeys) {
    Object.keys(obj).forEach((k) => {
      selectedKeys.includes(k) || delete _data[k];
    });
  }
  st = Object.values(_data).join("/");
  st = st.replace("//", "/");
  if (st[0] === "/") {
    st = st.substring(1, st.length);
  }
  if (st[st.length - 1] === "/") {
    st = st.substring(0, st.length - 2);
  }
  return st;
};
/**
 *
 * @param {*} data
 * @param {*} resource Resource type: resupply, order, shipment
 * @returns
 */
export const checkForClosedItem = (data, resource) => {
  if (!data) {
    return false;
  }
  var threshold;
  if (resource === "order") {
    if (
      data.paymentStatus === "cancelled" ||
      data.paymentStatus === "delivered"
    ) {
      // How long the item remains editable after it has been concluded
      threshold = 1000 * 60 * 60 * 24 * 7;
      if (
        Date.now() - new Date(Date.parse(data.updatedAt)).getTime() >
        threshold
      ) {
        return true;
      }
    }
    return false;
  }
  if (resource === "resupply") {
    if (
      data.paymentStatus === "cancelled" ||
      data.paymentStatus === "delivered"
    ) {
      // How long the item remains editable after it has been concluded
      threshold = 1000 * 60 * 60 * 24 * 7;
      if (
        Date.now() - new Date(Date.parse(data.updatedAt)).getTime() >
        threshold
      ) {
        return true;
      }
    }
    return false;
  }
  if (resource === "shipment") {
    if (data.status === "cancelled" || data.status === "delivered") {
      // How long the item remains editable after it has been concluded
      threshold = 1000 * 60 * 60 * 24 * 7;
      if (
        Date.now() - new Date(Date.parse(data.updatedAt)).getTime() >
        threshold
      ) {
        return true;
      }
    }
    return false;
  }
  return false;
};

/**
 *
 * @param {JSON | string} data Object or string to search for the query
 * @param {string} value Search query string
 * @param {string} subkey Search within specific key in object
 * @param {Function} translationfunction Function to modify the searched values before comparison
 * @returns
 */
export const findValueInText = (data, value, subkey, translationfunction) => {
  if (!value) {
    return true;
  }
  if (data && value && translationfunction) {
    return data
      .map((m) => translationfunction(m))
      .join(" ")
      .toLowerCase()
      .includes(value.toLowerCase());
  }
  if (subkey && data && Array.isArray(data)) {
    return data
      .map((m) => m[subkey])
      .join(" ")
      .toLowerCase()
      .includes(value.toLowerCase());
  }
  if (data && typeof data === "object") {
    return JSON.stringify(data).toLowerCase().includes(value.toLowerCase());
  }
  if (data) {
    return data.toLowerCase().includes(value.toLowerCase());
  }
  return false;
};

// Reference for the old invoice issuer structure. Runtime data comes from the API.
export const invoiceIssuers = {
  finland: {
    name: "Cryotech Finland Oy",
    street: "Jaakonkatu 2",
    location: "01620 Vantaa",
    vat: "FI25386878",
    companyPhone: "",
    companyEmail: "sales@ctn.fi",
    companyWebsite: "https://www.ctn.fi",
    bankName: "",
    bankAddress: "",
    bankSwift: "",
    bankCode: "",
    accountName: "Cryotech Finland Oy",
    bankIban: "",
  },
  estonia: {
    name: "Cryotech Nordic OU",
    street: "Joa tee 13",
    location: "76903 Harjumaa",
    vat: "EE101634087",
    companyPhone: "+372 530 53911",
    companyEmail: "sales@ctn.fi",
    companyWebsite: "https://www.ctn.fi",
    bankName: "LHV Pank AS",
    bankAddress: "Tartu mnt 2, 10145 Tallinn, Estonia",
    bankSwift: "LHVBEE22",
    bankCode: "689",
    accountName: "CRYOTECH NORDIC OU",
    bankIban: "EE037700771001284196",
  },
};

export const warehouseAddresses = {
  mailhouse: {
    name: "Mailhouse Oy",
    street: "Posliinitehtaankatu 1",
    location: "04260 Kerava",
  },
  finland: {
    name: "Cryotech Finland Oy",
    street: "Jaakonkatu 2",
    location: "01620 Vantaa",
  },
  vantaa: {
    name: "Cryotech Finland Oy",
    street: "Jaakonkatu 2",
    location: "01620 Vantaa",
  },
  estonia: {
    name: "Cryotech Nordic OU",
    street: "Joa tee 13",
    location: "76903 Harjumaa",
  },
  reimax: {
    name: "Reimax Electronics Oy",
    street: "Yrittäjäntie 6",
    location: "01800 Klaukkala",
  },
};

/**
 *
 * Matches the search value for the array of objects, returns true if found or if no object are provided
 *
 * @param {Array<JSON>} arr
 * @param {String} search_value
 * @returns Boolean
 */

export const searchMatchingList = (arr, search_value) => {
  if (!arr || !arr.length) {
    return true;
  }
  for (let index = 0; index < arr.length; index++) {
    const element = arr[index];
    if (findValueInText(element, search_value)) {
      return true;
    }
  }
  return false;
};

/**
 *
 * @param {JSON} order Order data
 * @param {JSON} item Item data
 * @returns {Number}
 */

export const getItemsInShipments = (order, item) => {
  if (!order || !order?.Shipments || !order.Shipments.length) {
    return "";
  }
  return order.Shipments.reduce((prev, curr) => {
    if (curr.status === "cancelled") {
      return prev;
    }
    const shipmentItems = Array.isArray(curr.genericDevices)
      ? curr.genericDevices
      : [];
    return (
      prev +
      (shipmentItems.find(
        (a) =>
          (a.id && item.id && a.id === item.id) ||
          (a.sku && item.sku && a.sku === item.sku) ||
          (a.name && item.name && a.name === item.name),
      )?.count || 0)
    );
  }, 0);
};

export const tableAlternateColors = (data, index) => {
  var obj = { cursor: "pointer" };
  if (Object.keys(obj).length === 1 && index % 2 === 0) {
    obj.backgroundColor = "rgba(245, 245, 245, 1)";
  }
  return obj;
};
